import { Outlet, useLocation, useMatches, useSearchParams } from 'react-router-dom';

import { NoAccessScreen } from '../components/NoAccessScreen';
import { useAccessContext } from '../hooks';
import { reportBranchWouldDeny } from '../reporting';

import { decideBranch } from './routeAccess';

export const RouteAccessGate = () => {
  const matches = useMatches();
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const { me, policy } = useAccessContext();
  const branch = decideBranch(me, matches, searchParams);

  if (branch.decision.allow) return <Outlet />;
  if (policy === 'report-only') {
    reportBranchWouldDeny(branch, pathname);
    return <Outlet />;
  }
  return <NoAccessScreen key={pathname} reason={branch.decision.reason} atPlant={branch.failed?.scope.kind === 'plant'} />;
};
